import { BuildingRestaurant, ChainLink } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { DateTime } from 'luxon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useIsMobile, MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography as T } from 'common/typography';

export type CoreDetailsProps = {
  venueName: string;
  expiresIn: string;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
  }
`;

const Item = styled(T.Body3)`
  display: flex;
  align-items: center;
`;

const Icon = styled.span`
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-inline-end: 4px;
  fill: ${cbSemanticCssVars.textSecondary};
`;

const CoreDetails = ({ venueName, expiresIn }: CoreDetailsProps) => {
  const isMobile = useIsMobile();
  const expirationDate = expiresIn
    ? DateTime.fromISO(expiresIn).toLocaleString(isMobile ? DateTime.DATETIME_SHORT : DateTime.DATETIME_MED)
    : null;

  return (
    <Root>
      <Item>
        <Icon>
          <BuildingRestaurant />
        </Icon>
        {isMobile ? venueName : <FormattedMessage id="photo-shoot.header.venue" values={{ name: venueName }} />}
      </Item>

      <Item>
        <Icon>
          <ChainLink />
        </Icon>
        {isMobile ? (
          expirationDate
        ) : (
          <FormattedMessage id="photo-shoot.header.link-expires" values={{ date: expirationDate }} />
        )}
      </Item>
    </Root>
  );
};

export default CoreDetails;
